
import { useContext, useEffect, useState } from "react";
import LogConsole from "./components/LogConsole/LogConsole";
import { DataProvider } from "./context/manageContext";
import Layout from "./Layout";
import authRequets from "./components/api/authRequests";
import { auth, db } from "./components/api/firebaseConfig";
import { collection, getDoc, getDocs } from "firebase/firestore";
import LoaderFetch from "./components/Common/LoaderFatch/Loader";
import mainContext from "./context/mainContext";
import GoogleAuth from "./components/Google/GoogleAuth/GoogleAuth";
import SplashScreen from "./pages/SplashScreen/SplashScreen";
import PWAInstallPrompt from "./components/PWAInstallPrompt/PWAInstallPrompt";
import { useWakeLock } from "./context/useWaklock";
import PreventPullToRefresh from "./components/PreventPullToReload/PreventPullToReload";
import OrientationWarning from "./components/OrientationWarning/OrientationWarning";


function App() {
  // const usersRef = collection(db, "errors");
  useEffect(() => {
    // authRequets.logOut()
    lockOrientation();
    window.buildType = getDeviceType() == "iOS" ? "iPhone" : "android";
    window.cordovaOn = process.env.REACT_APP_CORDOVA == "true" ? true : false;
    console.log("🚀 ~ file: App.jsx:22 ~ useEffect ~ window.cordovaOn:", window.cordovaOn)
    if (window.buildType == "iPhone") {
      let bodyEl = document.querySelector("body");
      let htmlEl = document.querySelector("html");
      let rootEL = document.querySelector("#root");
      bodyEl.style.setProperty('max-height', '100vh', 'important');
      bodyEl.style.setProperty('overflow-y', 'hidden', 'important');
      bodyEl.style.setProperty('padding-bottom', '0');

      htmlEl.style.setProperty('max-height', '100vh', 'important');
      htmlEl.style.setProperty('overflow-y', 'hidden', 'important');
      htmlEl.style.setProperty('padding-bottom', '0');

      rootEL.style.setProperty('position', 'fixed');
      rootEL.style.setProperty('top', '0');
      rootEL.style.setProperty('left', '0');
      rootEL.style.setProperty('margin', '0');
      rootEL.style.setProperty('height', '100vh');
      rootEL.style.setProperty('display', '');
      const images = document.querySelectorAll('img');
      const links = document.querySelectorAll('a');

      images.forEach(image => {
        image.addEventListener('click', function (event) {
          event.preventDefault();
        });
      });

      links.forEach(link => {
        link.addEventListener('click', function (event) {
          event.preventDefault();
        });
      });
    }
    // const getUsersList = async () => {
    //   const data = (await getDocs(usersRef)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
    //   console.log("all logs error:", data);
    //   let filteredArray = data.filter(item => {
    //     // Check if "errorInfo" exists and is an array
    //     if (item.errorInfo && Array.isArray(item.errorInfo)) {
    //       // Check if any object in "errorInfo" array has "from" key equal to "stopReadingData"
    //       return item.errorInfo.some(info => info.from === "stopReadingData");
    //     }
    //     return false; // If "errorInfo" doesn't exist or is not an array
    //   });
    //   console.log("those who has results: ", filteredArray)
    //   console.log("from todY WITH RESULTS:", filteredArray.filter(cell => {
    //     console.log(cell.errorInfo.find(cc => cc.from == "stopReadingData"))
    //     return cell.errorInfo.find(cc => cc.from == "stopReadingData").info.combinedIrisPosXMove[0].TS > (new Date().getTime() - (24 * 60 * 60 * 1000))
    //   }));
    // }
    // getUsersList()
  }, [])



  // Lock the screen orientation to portrait
  function lockOrientation() {
    if (window.screen.orientation && window.screen.orientation?.lock) {
      window.screen.orientation.lock("portrait").catch(function (error) {
        console.log("Orientation lock not allowed: ", error);
      });
    }
  }



  const [firstTime, setFirstTime] = useState(true);
  useWakeLock()
  return (
    <>
      {/* <PreventPullToRefresh> */}

      <DataProvider>
        {/* <GoogleAuth /> */}
        {/* <GoogleOAuthProvider clientId="408941723066-su818c8scn4qiugml1l8kpjfuvj9hnip.apps.googleusercontent.com">
        {/* <LogConsole /> */}
        <OrientationWarning />
        {firstTime ? <SplashScreen setFirstTime={setFirstTime} /> : <Layout />}
        <PWAInstallPrompt />
      </DataProvider>
      {/* </PreventPullToRefresh> */}
    </>
  );
}


function getDeviceType() {
  const userAgent = navigator.userAgent;

  if (/android/i.test(userAgent)) {
    return 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'iOS';
  } else {
    return 'Other';
  }
}

export default App;